import { createSelector } from 'reselect';

export const getAuth = (state) => state.auth;

export const getIsLoading = createSelector(getAuth, (auth) => auth.isLoading);

export const getUser = createSelector(getAuth, (auth) => auth.user || {});

export const getUserSession = createSelector(getAuth, (auth) => auth.userSession || {});

export const getIsFederated = createSelector(getUserSession, (user) => user.isFederated || false);

export const getUsername = createSelector(getUserSession, (user) => user.username);

export const getUserAttributes = createSelector(getUserSession, (user) => user.attributes || {});

export const getUserEmail = createSelector(getUser, (attributes) => attributes.email);

export const getUserId = createSelector(getUser, (attributes) => attributes.userId);
export const getUserIdentificationNumber = createSelector(
  getUser,
  (attributes) => attributes.identificationNumber
);

export const getUserFullName = createSelector(
  getUser,
  ({
    name = '', middleName = '', lastName = '', motherLastName = '',
  }) => `${name} ${middleName} ${lastName} ${motherLastName}`
);

export const getUserImage = createSelector(
  getUser,
  ({ avatar, }) => avatar || 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y' // TODO: buscar imagen apropiada
);

export const getHasUser = createSelector(getUsername, (username) => !!username);

export const getUserRoles = createSelector(getUser, ({ roles = [], }) => roles);

export const getUserPermissions = createSelector(getUser, ({ permissions = [], }) => permissions);

export const getUserPermissionsMap = createSelector(
  getUser,
  ({ permissions = [], }) => permissions.reduce(
    (index, permission) => ({
      ...index,
      [permission]: true,
    }),
    {}
  )
);

export const getCompany = createSelector(getAuth, (auth) => auth.company || {});

export const getCompanyId = createSelector(getCompany, (company) => company.companyId);

export const getCompanyBusinessName = createSelector(getCompany, (company) => company.businessName);

export const getClinic = createSelector(getAuth, (auth) => auth.clinic || {});
export const getClinicId = createSelector(getAuth, (auth) => auth.clinic?.clinicId);
export const getClinicName = createSelector(getAuth, (auth) => auth.clinic?.name);

export const getHasUserAndCompany = createSelector(
  getUsername,
  getCompanyId,
  (username, companyId) => !!username && !!companyId
);

export const getCompanies = createSelector(getAuth, (auth) => auth.companies || []);
